"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_lightning_core_1 = require("owa-lightning-core");
var EventEmitter = require("tiny-emitter");
function lightable(target) {
    var render = target.prototype.render;
    target.prototype.render = function () {
        if (owa_lightning_core_1.store.unseenItems) {
            var viewState = owa_lightning_core_1.store.unseenItems.get(this.props.lid);
            if (viewState && viewState.visible) {
                return render.call(this, arguments);
            }
        }
        return null;
    };
    var onMount = target.prototype.componentDidMount;
    target.prototype.componentDidMount = function () {
        if (onMount) {
            onMount.call(this, arguments);
        }
        owa_lightning_core_1.beginLightning.importAndExecute(this.props.lid, this.props.when, this.props.series);
    };
    var onUnmount = target.prototype.componentWillUnmount;
    target.prototype.componentWillUnmount = function () {
        if (onUnmount) {
            onUnmount.call(this, arguments);
        }
        owa_lightning_core_1.endLightning.importAndExecute(this.props.lid);
    };
    return target;
}
exports.lightable = lightable;
function lighted(lid) {
    owa_lightning_core_1.endLightning.importAndExecute(lid);
}
exports.lighted = lighted;
exports.eventMgr = new EventEmitter();
exports.SettingPanelFirstRunCalloutDismissedEvent = 'SettingPanelFirstRunCalloutDismissed';
//# sourceMappingURL=lightning.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-lightning/lib/components/lightning.js
// module id = 1621
// module chunks = 2 47 105 106 107